import type { UpdateUserPayload, UserResponse } from "@/api/users";

import { apiClient, endpoints } from "@/api";

/**
 * Endpoints for the signed-in user's own profile. `/me` is ungated so
 * dashboards can bootstrap and let users edit their own profile without
 * the admin-only `user:access` / `user:update` permissions that
 * `/users/{userId}` requires.
 */
export const meApi = {
	get: async (): Promise<UserResponse> => {
		const response = await apiClient.get<UserResponse>(endpoints.me.get);
		return response.data;
	},
	update: async (payload: UpdateUserPayload): Promise<UserResponse> => {
		const response = await apiClient.patch<UserResponse>(
			endpoints.me.update,
			payload,
		);
		return response.data;
	},
};
